export const API_URL =
  process.env.REACT_APP_API_ENV === "production"
    ? "https://api.asteride.co/api/v1/"
    : "http://asteride-dev.ap-south-1.elasticbeanstalk.com/api/v1/";
